import { CoralogixRum } from '@coralogix/browser';

import { Config } from '@sternum/web/config';
import { escapeStringRegExp } from '@sternum/web/utils';

if (Config.mode === 'production') {
  CoralogixRum.init({
    public_key: Config.coralogix.apiKey,
    application: Config.coralogix.appName,
    version: '0.0.1', // TODO: app versioning?
    coralogixDomain: Config.coralogix.domain,
    sessionRecordingConfig:
      Config.env === 'prod'
        ? {
            enable: true,
            autoStartSessionRecording: true,
            recordConsoleEvents: true,
          }
        : undefined,
    traceParentInHeader: {
      enabled: true,
      options: {
        propagateTraceHeaderCorsUrls: [escapeStringRegExp(Config.apiUrl)],
      },
    },
    environment: Config.env,
  });
}
